/**
 * Criterio de la vista RANGE de esta pestaña (selector de mes, tarjetas en vivo/congeladas, "Información
 * general"): la TARIFA de la psicóloga (`fee_type === 'range'`, ver usePsychologistFeeType), nunca el
 * ranking. Una psicóloga range sigue siendo range aunque su categoría cambie (NZ → O → …) — antes la vista
 * la elegía el recorrido NZ (`isNZ`, que sale del ranking) y al salir del recorrido se perdían sus tarjetas.
 * `isNZ` queda solo como respaldo mientras la tarifa no está disponible (`undefined`: el backend todavía no
 * manda el campo, o el fetch falló) — con la tarifa conocida (incluido `null`) no se mira.
 */
export function resolveIsRangeView(feeType: string | null | undefined, isNZFallback: boolean): boolean {
  return feeType === undefined ? isNZFallback : feeType === 'range';
}
